import { render, staticRenderFns } from "./autocomplete-multiple.vue?vue&type=template&id=4b2c1ef3&"
import script from "./autocomplete-multiple.vue?vue&type=script&lang=ts&"
export * from "./autocomplete-multiple.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports